import { Modal } from "src/components";
import { useAppSelector } from "src/redux/store";
import { translate } from "src/services";
import {
  Button,
  Column,
  Container,
  ModalSection,
  ModalTitle,
  Row,
  Separator,
  TextDisplay,
  Wrapper,
} from "src/styled";

interface Props {
  closeModal: () => void;
}

const ContactUsModal = ({ closeModal }: Props) => {
  const citySettings = useAppSelector(
    (state) => state.citySettings.settings?.vendorSettings
  );
  const handleEmailClick = () => {
    window.open(`mailto:${citySettings?.contactEmail}`, "_blank");
  };

  const handlePhoneClick = () => {
    window.open(`tel:${citySettings?.contactPhone}`, "_blank");
  };

  return (
    <Modal size="small" onClose={closeModal} padding="medium" title="">
      <>
        <Wrapper margin="no auto" maxWidth={400}>
          <ModalSection>
            <Separator height={50} />
            <ModalTitle fontSize="32px">
              <b> {translate("wizardPage.contactUsHeading")}</b>
            </ModalTitle>
            <TextDisplay block margin="medium no">
              {translate("wizardPage.contactUsSubHeading")}
            </TextDisplay>
          </ModalSection>
          <ModalSection>
            <Container fluid noMinHeight>
              {citySettings?.contactEmail && (
                <Row>
                  <Column size={3} padding="xSmall no">
                    {translate("common.email")}:
                  </Column>
                  <Column size={9} padding="xSmall no">
                    <Button
                      color="primary"
                      text
                      padding="no"
                      onClick={handleEmailClick}
                    >
                      <TextDisplay
                        singleLine
                        block
                        title={citySettings.contactEmail}
                      >
                        {citySettings.contactEmail}
                      </TextDisplay>
                    </Button>
                  </Column>
                </Row>
              )}
              {citySettings?.contactPhone && (
                <Row>
                  <Column size={3} padding="xSmall no">
                    {translate("common.phone")}:
                  </Column>
                  <Column size={9} padding="xSmall no">
                    <Button
                      color="primary"
                      text
                      padding="no"
                      onClick={handlePhoneClick}
                    >
                      {citySettings.contactPhone}
                    </Button>
                  </Column>
                </Row>
              )}
            </Container>
          </ModalSection>
          <Separator height={20} />
        </Wrapper>
      </>
    </Modal>
  );
};

export default ContactUsModal;
